/**
 * InfoBlock generates a block of content with an image, an optional title and a body of text.
 */

import React, { useState } from 'react';
import classnames from 'classnames';
import '../styles/index.scss';
import { Container, Col, Row } from 'react-bootstrap';
import { Media } from '../Media';
import Overlay from '../Overlay/Overlay';
var defaultProps = {
  title: '',
  text: '',
  quickLinks: null,
  backgroundColour: null,
  padding: null,
  imageAlt: '',
  imageSrc: '',
  children: false,
  hasEmbeddedVideo: false
};
/**
 * The InfoBlock component is responsible for building out the InfoBlock.
 * @param  {GatsbyImage} children
 * @param  {String} brand
 * @param  {Node} title
 * @param  {Node} text
 * @param  {String} imageAlt
 * @param  {String} imageSrc
 */
var InfoBlock = function InfoBlock(_ref) {
  var children = _ref.children,
    brand = _ref.brand,
    title = _ref.title,
    quickLinks = _ref.quickLinks,
    backgroundColour = _ref.backgroundColour,
    padding = _ref.padding,
    text = _ref.text,
    imageAlt = _ref.imageAlt,
    imageSrc = _ref.imageSrc,
    hasEmbeddedVideo = _ref.hasEmbeddedVideo;
  var isReview = padding === false;
  var isImageGallery = padding === true;
  var mediaWrapperStyling = classnames({
    'px-0 mb-3': true,
    'embed-responsive embed-responsive-16by9': hasEmbeddedVideo
  });
  var infoImageGallerySyling = classnames({
    'info-block-title': !isReview,
    'info-reviwe-block-title': isReview,
    'info-inmage-gallery-block-title': isImageGallery
  });
  var infoBlockStyling = classnames('info-block', {
    'desert-storm': backgroundColour === true,
    'reviwe-info-block': isReview
  });
  var infoTextSyling = classnames({
    'info-block-text': true,
    'info-image-gallery-block-text': isImageGallery
  });
  var _useState = useState(false),
    showModal = _useState[0],
    setShowModal = _useState[1];
  return /*#__PURE__*/React.createElement(Container, {
    brand: brand,
    className: infoBlockStyling
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: mediaWrapperStyling
  }, isImageGallery ? /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer",
    onClick: function onClick(e) {
      e.preventDefault();
      setShowModal(true);
    }
  }, children || /*#__PURE__*/React.createElement(Media, {
    src: imageSrc,
    alt: imageAlt
  })) : children || /*#__PURE__*/React.createElement(Media, {
    src: imageSrc,
    alt: imageAlt
  }))), title && /*#__PURE__*/React.createElement(Row, {
    "data-testid": "info-block-title",
    className: infoImageGallerySyling
  }, isImageGallery ? /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer",
    onClick: function onClick(e) {
      e.preventDefault();
      setShowModal(true);
    }
  }, /*#__PURE__*/React.createElement(Col, {
    className: "pl-0 pb-2"
  }, title)) : /*#__PURE__*/React.createElement(Col, {
    className: "pl-0 pb-2"
  }, title)), text && !isImageGallery && /*#__PURE__*/React.createElement(Row, {
    "data-testid": "info-block-text",
    className: infoTextSyling
  }, /*#__PURE__*/React.createElement(Col, {
    className: "pl-0"
  }, text)), (quickLinks === null || quickLinks === void 0 ? void 0 : quickLinks.text) && (quickLinks === null || quickLinks === void 0 ? void 0 : quickLinks.url) && /*#__PURE__*/React.createElement(Row, null, isImageGallery ? /*#__PURE__*/React.createElement("button", {
    className: "info-block-link info-image-gallery-block-link",
    onClick: function onClick(e) {
      e.preventDefault();
      setShowModal(true);
    }
  }, quickLinks === null || quickLinks === void 0 ? void 0 : quickLinks.text) : /*#__PURE__*/React.createElement("a", {
    href: quickLinks === null || quickLinks === void 0 ? void 0 : quickLinks.url,
    className: "info-block-link btn btn-primary outline"
  }, quickLinks === null || quickLinks === void 0 ? void 0 : quickLinks.text)), /*#__PURE__*/React.createElement(Overlay, {
    modalClassNames: "modal-sm-bottom",
    onClose: function onClose() {
      return setShowModal(false);
    },
    show: showModal,
    showFooter: false,
    title: title
  }, text, children || /*#__PURE__*/React.createElement(Media, {
    src: imageSrc,
    alt: imageAlt
  })));
};
InfoBlock.defaultProps = defaultProps;
export { InfoBlock };